import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const EntityCommentList = ({ parentEntity, parentEntityId }) => {

  const augRowsReq = useCallback((rowsReq) => {
    if (!parentEntity) return;
    rowsReq.expr = ExprUtils.whereParams('entity', parentEntity, 'entityId', parentEntityId);
  }, [parentEntity, parentEntityId])

  return (
    <EntityList
      entity="ENTITY_COMMENT"
      augRowsReq={augRowsReq}
    />
  )
}